import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import useMutation from '../../modules/react/hooks/useMutation';
import BlogPostForm from '../components/BlogPostForm';
import { GET_BLOG_DATA_QUERY } from '../../src/admin/modules/blog/containers/List';

export const GET_BLOG_POST = gql`
  query GetBlogEditPostData($id: ID!) {
    blogPost(id: $id) {
      id
      ...BlogPostFormBlogPost
    }
  }

  ${BlogPostForm.fragments.post}
`;

export const UPDATE_BLOG_POST = gql`
  mutation updateBlogPost($id: ID!, $post: BlogPostUpdateInput!) {
    blogPostUpdate(id: $id, post: $post) {
      post {
        id
        ...BlogPostFormBlogPost
      }
      userErrors {
        code
        message
      }
    }
  }

  ${BlogPostForm.fragments.post}
`;

const propTypes = {
  params: PropTypes.object({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const successMessage = 'Blog post updated successfully';

const BlogPostEditContainer = ({
  params: { id },
}) => {
  const { data } = useQuery(GET_BLOG_POST, { variables: { id } });

  const [updateBlogPost, {
    data: updateData,
    loading,
  }] = useMutation(UPDATE_BLOG_POST, {
    refetchQueries: [GET_BLOG_DATA_QUERY],
  });

  if (!data) {
    return null;
  }

  const onSubmit = post => updateBlogPost({ variables: { id, post } });

  const errors = updateData?.blogPostUpdate?.userErrors?.length
    ? updateData.blogPostUpdate.userErrors
    : undefined;

  return (
    <BlogPostForm
      errors={errors}
      isSubmitting={loading}
      onSubmit={onSubmit}
      post={data.blogPost}
      successMessage={successMessage}
      {...data}
    />
  );
};

BlogPostEditContainer.propTypes = propTypes;
BlogPostEditContainer.defaultProps = defaultProps;

export default BlogPostEditContainer;
